import { EventViewData } from 'components/eventView/pages/eventData';

export const MarenaShowcaseEvent: EventViewData = {
    eventId: 'marenaa',
    mapId: 'a61e0f30-9b6c-448b-bd3f-254777931a67',
    guideId: '50ed42a5-bb7d-46ef-a7bb-d63cefd342fa',
    eventInfo: {
        order: {
            mobile: [
                'home',
                '05fcb38a-0503-4fdf-91fc-d4e18c63fc4c',
                'map',
                'program',
                'information'
            ],
            wide: [
                'home',
                '05fcb38a-0503-4fdf-91fc-d4e18c63fc4c',
                'program',
                '...',
                'information',
                'map'
            ],
            primes: ['05fcb38a-0503-4fdf-91fc-d4e18c63fc4c'],
            normal: ['program', '...', 'information']
        }
    }
};
